import {charcoal} from '../sass/base/_exports.sass';

export const FiltersIcon = ({color = charcoal, className = '', ratio = 1}) => {
  // default dimensions
  const width = 32;
  const height = 32;

  // Use ratio to calculate width and height
  const style = {height: `${ratio * height}px`, width: `${ratio * width}px`};

  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: Fix me!
    <svg
      viewBox={`0 0 ${width} ${height}`}
      fill="none"
      style={style}
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M22 17.3333C19.8933 17.3333 18.1293 18.7467 17.5507 20.6667H2.66667V23.3333H17.5507C18.1293 25.2533 19.8933 26.6667 22 26.6667C24.1067 26.6667 25.8707 25.2533 26.4493 23.3333H29.3333V20.6667H26.4493C25.8707 18.7467 24.1067 17.3333 22 17.3333ZM22 24C20.8973 24 20 23.1027 20 22C20 20.8973 20.8973 20 22 20C23.1027 20 24 20.8973 24 22C24 23.1027 23.1027 24 22 24Z"
        fill={color}
      />
      <path
        d="M17.116 10C16.5373 8.08 14.7733 6.66666 12.6667 6.66666C10.56 6.66666 8.79601 8.08 8.21734 10H2.66667V12.6667H8.21734C8.79601 14.5867 10.56 16 12.6667 16C14.7733 16 16.5373 14.5867 17.116 12.6667H29.5V10H17.116ZM12.6667 13.3333C11.564 13.3333 10.6667 12.436 10.6667 11.3333C10.6667 10.2307 11.564 9.33333 12.6667 9.33333C13.7693 9.33333 14.6667 10.2307 14.6667 11.3333C14.6667 12.436 13.7693 13.3333 12.6667 13.3333Z"
        fill={color}
      />
    </svg>
  );
};
